import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError, } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnvironmentConfiguration } from '../environment/services/environment.configuration';
var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
var httpOptions;
if (isIEOrEdge) {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
    })
  };
} else {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('Ebom_accessToken'),
      'x-api-key':localStorage.getItem('Filename')
    })
  };
}
@Injectable({
  providedIn: 'root'
})
export class ManualAdjustmentRuleService {

  gridData = '/getManAdjRuleGrid/{proxy+}';
  family = '/getFamilyBpMar/{proxy+}'
  ruleType = '/getRuleTypeBpMar/{proxy+}'
  versionName = '/getVersionNameBpMar/{proxy+}'
  namc = '/getNamcBpMar/{proxy+}'
  grpi = '/getGrpiBpMar/{proxy+}'
  partNumber = '/getPartNoMar/{proxy+}'
  ruleStatus = '/getRuleStatusMar/{proxy+}'
  katashiki = '/getKatashikiBpMar/{proxy+}'




  constructor(private http: HttpClient, private environment: EnvironmentConfiguration) { }
  //rule type
  getRuleTypeBpMar(): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = this.environment.BusinesssearchdropdownapiUrl + this.ruleType + '?page=' + ''+'&screenNo=NBPC_10122'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)
      )
  }
  //version Name
  getVersionNameBpMar(ruleTyp): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let versionNameParams = new HttpParams().set('ruleTyp', ruleTyp)
    let API_URL = this.environment.BusinesssearchdropdownapiUrl + this.versionName + "?ruleTyp=" + ruleTyp +'&screenNo=NBPC_10122'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)

      .pipe(
        catchError(this.error)
      )
  }
  //namc
  getNamcBpMar(ruleTyp, VerTypCd): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let namcParams = new HttpParams().set('ruleTyp', ruleTyp)
    //   .append('VerTypCd', VerTypCd)

    let API_URL = this.environment.BusinesssearchdropdownapiUrl + this.namc + "?ruleTyp=" + ruleTyp + '&VerTypCd=' + VerTypCd+'&screenNo=NBPC_10122'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)
      )
  }
  //family
  getFamilyBpMar(ruleTyp, VerTypCd, namc): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let familyParams = new HttpParams().set('ruleTyp', ruleTyp)
    //   .append('VerTypCd', VerTypCd)
    //   .append('namcId', namc)
    let API_URL = this.environment.BusinesssearchdropdownapiUrl + this.family 
    + "?ruleTyp=" + ruleTyp + '&VerTypCd=' + VerTypCd
      + '&namcId=' + namc+'&screenNo=NBPC_10122'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)

      .pipe(
        catchError(this.error)
      )
  }
  //grpi
  getGrpiBpMar(namc, famCd, katashikiCd): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let GrpiParams = new HttpParams().set('namcId', namc)
    //   .append('famCd', famCd)
    //   .append('katashikiCd', katashikiCd)
    let API_URL = this.environment.BusinesssearchdropdownapiUrl + this.grpi + '?namcId=' + namc +
      '&famCd=' + famCd + '&katashikiCd=' + katashikiCd+'&screenNo=NBPC_10122'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)
      )
  }

  //part Number
  getPartNoMar(namc, famCd, katashikiCd, grpiCd): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let partNumberParams = new HttpParams().set('namcId', namc)
    //   .append('famCd', famCd)
    //   .append('katashikiCd', katashikiCd)
    //   .append('grpiCd', grpiCd)
    let API_URL = this.environment.BusinesssearchdropdownapiUrl + this.partNumber + '?namcId=' + namc +
      '&famCd=' + famCd + '&katashikiCd=' + katashikiCd + '&grpiCd=' + grpiCd+'&screenNo=NBPC_10122'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)
      )
  }

  //katashiki
  getkatashikiMar(namc, famCd): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let katashikiParams = new HttpParams().set('namcId', namc)
    //   .append('famCd', famCd)
    let API_URL = this.environment.BusinesssearchdropdownapiUrl + this.katashiki + '?namcId=' + namc + '&famCd=' + famCd+'&screenNo=NBPC_10122'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)
      )
  }

  //rule Status
  getRuleStatusMar(namc, famCd, katashikiCd, grpiCd, partNo): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let ruleStatusParams = new HttpParams().set('namcId', namc)
    //   .append('famCd', famCd)
    //   .append('katashikiCd', katashikiCd)
    //   .append('grpiCd', grpiCd)
    //   .append('partNo', partNo)
    let API_URL = this.environment.BusinesssearchdropdownapiUrl + this.ruleStatus + '?namcId=' + namc +
      '&famCd=' + famCd + '&katashikiCd=' + katashikiCd + '&grpiCd=' + grpiCd + '&partNo=' + partNo+'&screenNo=NBPC_10122'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)
      )
  }

  //grid data
  getGridData(gridData): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let gridParams = new HttpParams().set('ruleTyp', gridData.ruleType)
    //   .append('verNm', gridData.versionName)
    //   .append('namc', gridData.namc)
    //   .append('family', gridData.family)
    //   .append('katashiki', gridData.katasPart)
    //   .append('grpi', gridData.grpi)
    //   .append('partNum', gridData.partNo)
    //   .append('ruleSts', gridData.ruleStatus)
    //   .append('createdFrmDt', gridData.createFromDt)
    //   .append('createdToDt', gridData.createToDt)
    //   .append('option', gridData.option)
    //   .append('fileName', gridData.fileName)
    let API_URL = this.environment.BussinessgridapiUrl + this.gridData + "?ruleTyp=" + gridData.ruleType
      + '&verNm=' + gridData.versionName + '&namc=' + gridData.namc + '&family=' + gridData.family
      + '&katashiki=' + gridData.katasPart + '&grpi=' + gridData.grpi + '&partNum=' + gridData.partNo
      + '&ruleSts=' + gridData.ruleStatus + '&createdFrmDt=' + gridData.createFromDt + '&createdToDt=' + gridData.createToDt
      + '&option=' + gridData.option + '&GfileName=' + gridData.fileName+'&screenNo=NBPC_10122'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)
      )
  }
  fileUpldData(): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    return this.http.get(this.environment.NewURL+'/AssumeRole/{proxy+}'+'?screenNo=NBPC_10122'+'&fileName=' +fileName, httpOptions)
      .pipe(map((response: any) => response), catchError(this.error))
  }

  // Handle Errors 
  error(error: HttpErrorResponse) {
    let errorMessage:any = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = error.status;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }


}
